import services from 'services/services';
import * as types from '../../types';

// Import helpers
import { checkFetchErrors } from '../../helpers_actions/convert_helpers';

// ******************** FETCH ARTICLE TITLE FILES TO EDIT ********************
export const fetchArticleTitle = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_ARTICLE_TITLE_FILES_LOADING,
			payload: true
		});

		const response = await services.get(
			`/assets/${id}/list?model_type=article&collection=title`
		);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_ARTICLE_TITLE_FILES_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_ARTICLE_TITLE_FILES_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
